import React from 'react';
import Link from '@atlaskit/link';
import { useLocation } from 'react-router-dom';
import { useRegisterComponent } from '../../orchestrator';

export const ResetPasswordLink = ({ children }: { children: React.ReactNode }) => {
  useRegisterComponent(ResetPasswordLink.name);

  const { search } = useLocation();

  return (
    <Link href={'/login/resetpassword' + search} id="resetPassword">
      {children}
    </Link>
  );
};
